import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const loadUnitInventory = async (params) => {
	const { data } = await axios.post(`${API}/client/implementation/save_products`, {
		params,
	});
	return data;
};
